import type { Movie } from "@/types";

export const movies: Movie[] = [
  {
    id: "m1",
    title: "星河远征",
    alias: "Star Voyage: The Long Journey",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20art%20of%20a%20lone%20astronaut%20standing%20before%20a%20colossal%20glowing%20space%20station%2C%20deep%20navy%20blue%20background%20with%20warm%20golden%20light%20streaks%2C%20dramatic%20scale%2C%20minimal%20high%20detail%20composition%2C%20no%20text&width=600&height=900&seq=qx-movie-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20sci-fi%20backdrop%20of%20a%20vast%20space%20fleet%20drifting%20above%20a%20blue%20planet%2C%20deep%20navy%20tones%20with%20golden%20rim%20light%2C%20atmospheric%20nebula%2C%20epic%20scale%2C%20minimal%20high%20detail%2C%20no%20text&width=1600&height=900&seq=qx-movie-01-bd&orientation=landscape",
    type: "电影",
    genres: ["科幻", "冒险", "剧情"],
    region: "大陆",
    year: 2024,
    rating: 8.7,
    duration: "148分钟",
    director: "陈屿",
    actors: ["林知远", "周予安", "苏黎", "郑砚青"],
    synopsis:
      "近未来，地球资源枯竭，一支由顶尖宇航员组成的远征队踏上寻找新家园的漫长旅途。当飞船穿越虫洞抵达未知星系，队员们必须在希望与牺牲之间做出抉择。影片以宏大的宇宙尺度，讲述了一个关于勇气、信念与归途的故事。",
    updatedAt: "2024-07-18",
    heat: 9860,
  },
  {
    id: "m2",
    title: "暗夜追凶",
    alias: "Night Pursuit",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20crime%20thriller%20movie%20poster%20of%20a%20detective%20silhouette%20walking%20through%20rainy%20neon%20streets%20at%20night%2C%20deep%20navy%20blue%20palette%20with%20crimson%20red%20glow%20accents%2C%20moody%20dramatic%20lighting%2C%20minimal%20high%20detail%2C%20no%20text&width=600&height=900&seq=qx-movie-02&orientation=portrait",
    type: "电影",
    genres: ["悬疑", "犯罪", "惊悚"],
    region: "港台",
    year: 2023,
    rating: 8.2,
    duration: "132分钟",
    director: "杜峰",
    actors: ["张家豪", "李婉婷", "欧阳靖"],
    synopsis:
      "一桩尘封多年的悬案重启调查，退休刑警被迫重回一线。随着线索层层揭开，他发现真相比想象中更加复杂，而凶手或许一直藏在自己身边。影片节奏紧凑，悬念环环相扣。",
    updatedAt: "2023-11-02",
    heat: 8420,
  },
  {
    id: "m3",
    title: "山海之城",
    alias: "City of Mountains and Seas",
    poster:
      "https://readdy.ai/api/search-image?query=Epic%20fantasy%20movie%20poster%20of%20an%20ancient%20oriental%20city%20floating%20among%20clouds%20between%20mountains%20and%20sea%2C%20deep%20navy%20and%20gold%20palette%2C%20mythical%20creatures%20in%20the%20sky%2C%20dramatic%20minimal%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=qx-movie-03&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Epic%20fantasy%20landscape%20backdrop%20of%20a%20vast%20oriental%20city%20nestled%20between%20towering%20mountains%20and%20a%20glowing%20sea%2C%20deep%20navy%20sky%20with%20golden%20light%2C%20mythical%20atmosphere%2C%20cinematic%20high%20detail%2C%20no%20text&width=1600&height=900&seq=qx-movie-03-bd&orientation=landscape",
    type: "电影",
    genres: ["奇幻", "动作", "冒险"],
    region: "大陆",
    year: 2025,
    rating: 7.9,
    duration: "155分钟",
    director: "顾承宇",
    actors: ["沈亦舟", "白露", "柳青梧"],
    synopsis:
      "传说中的山海之城重现人间，一位背负家族宿命的少年踏上寻城之旅。他需要集齐散落各地的上古灵印，才能唤醒沉睡的神兽，阻止一场席卷天下的浩劫。",
    updatedAt: "2025-02-20",
    heat: 9120,
  },
  {
    id: "m4",
    title: "沙漠之心",
    alias: "Heart of the Desert",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20drama%20movie%20poster%20of%20two%20figures%20standing%20on%20a%20vast%20golden%20desert%20dune%20at%20sunset%2C%20warm%20amber%20and%20deep%20navy%20sky%2C%20soft%20cinematic%20light%2C%20minimal%20emotional%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=qx-movie-04&orientation=portrait",
    type: "电影",
    genres: ["剧情", "爱情"],
    region: "欧美",
    year: 2022,
    rating: 8.0,
    duration: "121分钟",
    director: "Elena Marsh",
    actors: ["Clara Reeves", "Noah Bennett", "Ruby Hale"],
    synopsis:
      "一位地质学家与一名向导穿越撒哈拉沙漠，途中遭遇风暴与迷失。在极端环境中，两个原本陌生的人彼此依靠，重新审视各自的人生与牵挂。",
    updatedAt: "2022-09-30",
    heat: 7180,
  },
  {
    id: "m5",
    title: "时间回廊",
    alias: "Corridor of Time",
    poster:
      "https://readdy.ai/api/search-image?query=Mind-bending%20sci-fi%20mystery%20movie%20poster%20of%20a%20man%20standing%20in%20an%20infinite%20mirrored%20corridor%20with%20glowing%20clock%20fragments%2C%20deep%20navy%20and%20teal%20tones%2C%20surreal%20minimal%20composition%2C%20high%20detail%2C%20no%20text&width=600&height=900&seq=qx-movie-05&orientation=portrait",
    type: "电影",
    genres: ["科幻", "悬疑"],
    region: "欧美",
    year: 2024,
    rating: 8.5,
    duration: "138分钟",
    director: "Marcus Cole",
    actors: ["Olivia Hart", "Julian Reed", "Ethan Ward"],
    synopsis:
      "物理学家在一次实验事故后陷入时间循环，每天醒来都是同一个清晨。他必须利用无数次重置中积累的线索，找到打破循环的唯一方法。",
    updatedAt: "2024-05-11",
    heat: 8940,
  },
  {
    id: "m6",
    title: "长夜将尽",
    alias: "Before the Dawn",
    poster:
      "https://readdy.ai/api/search-image?query=Historical%20drama%20movie%20poster%20of%20a%20solitary%20figure%20in%20traditional%20coat%20standing%20on%20a%20snowy%20old%20city%20street%20at%20dawn%2C%20muted%20navy%20and%20warm%20sepia%20palette%2C%20somber%20cinematic%20lighting%2C%20minimal%20high%20detail%2C%20no%20text&width=600&height=900&seq=qx-movie-06&orientation=portrait",
    type: "电影",
    genres: ["剧情", "历史"],
    region: "大陆",
    year: 2023,
    rating: 8.8,
    duration: "162分钟",
    director: "韩子墨",
    actors: ["王砚秋", "赵暮云", "沈之洲"],
    synopsis:
      "故事发生在一个动荡年代。一位教书先生在城市最黑暗的时刻，用知识与良知守护着一群学生，直到长夜将尽、黎明到来。影片以克制的镜头语言讲述普通人的坚守。",
    updatedAt: "2023-12-15",
    heat: 9210,
  },
  {
    id: "s1",
    title: "长安记事",
    alias: "Chronicles of Chang'an",
    poster:
      "https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%20of%20an%20elegant%20official%20in%20ancient%20silk%20robe%20standing%20before%20a%20grand%20palace%20at%20night%2C%20deep%20navy%20and%20gold%20palette%2C%20lanterns%20glow%2C%20minimal%20high%20detail%2C%20no%20text&width=600&height=900&seq=qx-series-01&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20capital%20city%20panorama%20at%20dusk%20with%20palaces%20pagodas%20and%20lantern-lit%20streets%2C%20deep%20navy%20sky%20with%20warm%20golden%20lantern%20light%2C%20cinematic%20historical%20high%20detail%2C%20no%20text&width=1600&height=900&seq=qx-series-01-bd&orientation=landscape",
    type: "电视剧",
    genres: ["古装", "历史", "剧情"],
    region: "大陆",
    year: 2024,
    rating: 8.9,
    duration: "45分钟/集",
    director: "苏牧",
    actors: ["陆时昭", "温瑶", "裴行舟", "柳青梧"],
    synopsis:
      "以一座繁华古都为舞台，讲述年轻官员在朝堂与市井之间周旋，凭借智慧与担当破解一桩桩奇案，并在权力漩涡中坚守初心的故事。全剧考究的服化道还原盛世气象。",
    updatedAt: "2024-08-25",
    heat: 9980,
  },
  {
    id: "s2",
    title: "都市迷雾",
    alias: "Urban Fog",
    poster:
      "https://readdy.ai/api/search-image?query=Modern%20urban%20mystery%20series%20poster%20of%20a%20journalist%20standing%20on%20a%20city%20rooftop%20surrounded%20by%20dense%20fog%20and%20skyscrapers%2C%20deep%20navy%20and%20crimson%20red%20accents%2C%20moody%20cinematic%20light%2C%20minimal%20high%20detail%2C%20no%20text&width=600&height=900&seq=qx-series-02&orientation=portrait",
    type: "电视剧",
    genres: ["悬疑", "都市", "犯罪"],
    region: "大陆",
    year: 2025,
    rating: 8.1,
    duration: "42分钟/集",
    director: "陈屿",
    actors: ["周予安", "林知远", "苏黎"],
    synopsis:
      "一名调查记者在追踪一桩上市公司丑闻时，意外牵出隐藏在城市光鲜表象下的巨大阴谋。随着真相逼近，她发现每个知情者都在说谎。",
    updatedAt: "2025-03-08",
    heat: 8760,
  },
  {
    id: "s3",
    title: "心跳信号",
    alias: "Heartbeat Signal",
    poster:
      "https://readdy.ai/api/search-image?query=Romantic%20korean%20drama%20poster%20of%20a%20couple%20sharing%20earphones%20under%20warm%20city%20lights%20at%20night%2C%20soft%20amber%20and%20navy%20tones%2C%20tender%20cinematic%20atmosphere%2C%20minimal%20high%20detail%2C%20no%20text&width=600&height=900&seq=qx-series-03&orientation=portrait",
    type: "电视剧",
    genres: ["爱情", "都市"],
    region: "韩国",
    year: 2023,
    rating: 7.8,
    duration: "60分钟/集",
    director: "Kim Do-yun",
    actors: ["Han Seo-jin", "Park Ji-hoon", "Lee Ha-eun"],
    synopsis:
      "一位对声音极度敏感的电台主播，与一位总在深夜打来电话的陌生听众逐渐产生默契。当两人在现实中相遇，一段关于治愈与重逢的故事就此展开。",
    updatedAt: "2023-10-19",
    heat: 7010,
  },
  {
    id: "s4",
    title: "权力的边界",
    alias: "The Edge of Power",
    poster:
      "https://readdy.ai/api/search-image?query=Political%20drama%20series%20poster%20of%20a%20solemn%20leader%20standing%20in%20a%20dim%20marble%20hall%20with%20tall%20columns%2C%20deep%20navy%20and%20steel%20grey%20palette%20with%20gold%20accents%2C%20dignified%20cinematic%20lighting%2C%20minimal%20high%20detail%2C%20no%20text&width=600&height=900&seq=qx-series-04&orientation=portrait",
    type: "电视剧",
    genres: ["剧情", "政治", "历史"],
    region: "欧美",
    year: 2022,
    rating: 9.0,
    duration: "55分钟/集",
    director: "Gregory Shaw",
    actors: ["Nina Coleman", "Adam Foster", "Grace Nolan"],
    synopsis:
      "围绕一场国家危机，讲述一群身处权力中心的人物如何在理想与现实之间挣扎。剧集以多线叙事呈现决策背后的博弈，被誉为近年最具深度的政治剧之一。",
    updatedAt: "2022-06-12",
    heat: 9350,
  },
  {
    id: "s5",
    title: "江湖夜雨",
    alias: "Rain of the Jianghu",
    poster:
      "https://readdy.ai/api/search-image?query=Wuxia%20martial%20arts%20series%20poster%20of%20a%20swordsman%20standing%20in%20bamboo%20forest%20under%20rain%20at%20night%2C%20deep%20navy%20and%20jade%20green%20tones%20with%20gold%20accents%2C%20moody%20cinematic%20atmosphere%2C%20minimal%20high%20detail%2C%20no%20text&width=600&height=900&seq=qx-series-05&orientation=portrait",
    type: "电视剧",
    genres: ["武侠", "动作", "古装"],
    region: "大陆",
    year: 2023,
    rating: 8.3,
    duration: "40分钟/集",
    director: "顾承宇",
    actors: ["沈亦舟", "柳青梧", "白露"],
    synopsis:
      "少年剑客为查明师门旧案真相，独自踏入波谲云诡的江湖。刀光剑影之间，他逐渐明白真正的侠义不在快意恩仇，而在守护心中所信之人。",
    updatedAt: "2023-09-05",
    heat: 8120,
  },
  {
    id: "s6",
    title: "未来档案",
    alias: "Future File",
    poster:
      "https://readdy.ai/api/search-image?query=Japanese%20sci-fi%20thriller%20series%20poster%20of%20a%20figure%20facing%20a%20giant%20glowing%20data%20archive%20wall%20in%20a%20dark%20lab%2C%20deep%20navy%20and%20cyan%20tones%2C%20tense%20cinematic%20light%2C%20minimal%20high%20detail%2C%20no%20text&width=600&height=900&seq=qx-series-06&orientation=portrait",
    type: "电视剧",
    genres: ["科幻", "惊悚", "悬疑"],
    region: "日本",
    year: 2025,
    rating: 8.4,
    duration: "50分钟/集",
    director: "Sato Kenji",
    actors: ["Aoi Tanaka", "Ren Suzuki", "Mina Kato"],
    synopsis:
      "在不远的未来，人类可以调取任何被记录的记忆。一名档案管理员在一次例行检索中，发现了指向自己的犯罪记录，而那段记忆从未发生过。",
    updatedAt: "2025-04-16",
    heat: 8890,
  },
];

export const heroMovieIds = ["s1", "m1", "m3"];